// extracted by mini-css-extract-plugin
export default {"container":"CFeZy","text":"XoUGy","amount":"piaTY","error":"ocCAS","button":"SW_sc"};